"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genericImports = [
    'generic/base_csv',
    'generic/base_googledoc',
    'generic/base_json',
    'generic/base_xml',
    'generic/beezup',
    'generic/compario',
    'generic/googleshopping',
    'generic/googleshopping_csv',
    'generic/googleshopping_xml',
    'generic/googleshoppingcsvsem',
    'generic/import_utils',
    'generic/oxtemplate',
    'generic/oxtemplate_csv',
    'generic/oxtemplate_googledoc',
    'generic/oxtemplate_json',
    'generic/oxtemplate_xml',
    'generic/shopping',
    'generic/shoppingflux',
    'generic/shoppingflux_xml',
    'generic/spreadsheet',
    'generic/variant_xml',
    'generic/woocommerce',
];
exports.customImports = [
    'custom/aelia',
    'custom/aelia2018',
    'custom/allomatelas',
    'custom/alltricks',
    'custom/auchan',
    'custom/auchan_lark',
    'custom/beautyshop',
    'custom/carrefour_rentree',
    'custom/castorama',
    'custom/cdiscount',
    'custom/cdiscount_experimental',
    'custom/chullanka',
    'custom/croquetteland',
    'custom/desseres',
    'custom/distrimed',
    'custom/ekosport_lengow',
    'custom/guedo',
    'custom/jardiland',
    'custom/lengow',
    'custom/lengow_api',
    'custom/lengow_googleshopping',
    'custom/lilikim',
    'custom/lordelmusique',
    'custom/madeindesign',
    'custom/madeindesign_ch',
    'custom/madeindesign_uk',
    'custom/matalan',
    'custom/mathon',
    'custom/medimarket',
    'custom/multipharma',
    'custom/mypiscine',
    'custom/newpharma',
    'custom/newpharma_be',
    'custom/pacific_peche',
    'custom/peugeot_saveur',
    'custom/priceminister',
    'custom/salomon',
    'custom/test',
    'custom/thepowerhouse',
    'custom/yakarouler',
    'custom/zodio',
];
//# sourceMappingURL=imports.js.map